<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>ATK MOBILE EDIT</span>
        </div>
        <div class="header-sub-title">
          <span>{{ tabSelect }}</span>
        </div>
      </div>
      <div class="" v-loading="flagLoading.info || flagLoading.freqGraph">
        <el-tabs tab-position="left" v-model="tabSelect">
          <el-tab-pane label="Listening Tips" name="Listening Tips">
            <EditorTipTap :actionItem="infos.content.listening_tips" actionType="listening_tips" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="About Us" name="About Us">
            <EditorTipTap :actionItem="infos.content.about_us" actionType="about_us" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="FAQ" name="FAQ">
            <EditorTipTap :actionItem="infos.content.faq" actionType="faq" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="Frequency Graph" name="Frequency Graph">
            <div class="freq-graph">
              <div class="freq-item">
                <div class="item-title">
                  <span>SUB</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.sub.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.sub.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.sub.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>LOW</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.low.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.low.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.low.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>LO MID</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.lo_mid.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.lo_mid.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.lo_mid.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>MID</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.mid.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.mid.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.mid.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>HI MID</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.hi_mid.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.hi_mid.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.hi_mid.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>HI</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.hi.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.hi.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.hi.desc"></el-input>
                  </div>
                </div>
              </div>
              <div class="freq-item">
                <div class="item-title">
                  <span>AIR</span>
                </div>
                <div class="item-content">
                  <div class="item-inputs">
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.air.min">
                      <template #append>Hz</template>
                    </el-input>
                    <span> - </span>
                    <el-input class="input-hz" type="number" size="small" v-model.number="freqGraph.air.max">
                      <template #append>Hz</template>
                    </el-input>
                  </div>
                  <div class="item-desc">
                    <el-input class="input-desc" size="small" v-model="freqGraph.air.desc"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Menu" name="Menu">
            <div class="menu-list">
              <el-checkbox-group v-model="menu.list" size="large">
                <el-checkbox label="FREQUENCY GRAPHS" />
                <el-checkbox label="LISTENING GUIDE" />
                <el-checkbox label="DISCOGRAPHY" />
                <el-checkbox label="TECH SPECS" />
                <el-checkbox label="IMAGES" />
                <el-checkbox label="DEALS" />
                <el-checkbox label="SHARE" />
              </el-checkbox-group>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="infos-actions">
        <el-button size="small" class="el-btn-blue" @click="updateSettings" :loading="flagLoading.update">SAVE CHANGES</el-button>
        <el-button size="small" @click="returnBack">CANCEL</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import EditorTipTap from '@/components/editors/Tiptap'
import { reactive } from 'vue'
export default {
  name: 'GlobalGuides',
  components: {
    EditorTipTap
  },
  data () {
    const flagLoading = reactive({
      info: false,
      freqGraph: false,
      getMenu: false,
      update: false
    })
    return {
      tabSelect: 'Listening Tips',
      infos: { type: 'mobile_infos', content: {} },
      content: {},
      freqGraph: { sub: {}, low: {}, lo_mid: {}, mid: {}, hi_mid: {}, hi: {}, air: {} },
      menu: { list: [] },
      flagLoading
    }
  },
  created () {
    this.getSettings()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getSettings: function () {
      this.getInfo()
      this.getFreqGraph()
      this.getMenu()
    },
    getInfo: function () {
      if (this.flagLoading.info) return
      this.flagLoading.info = true
      const url = `/api/v1/atk_player/admin/settings/${this.infos.type}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.infos = res.data
          that.content = { ...that.content, ...res.data.content }
        } else {
          console.error('getInfo', res.msg)
        }
        that.flagLoading.info = false
      }).catch(function (err) {
        console.error('getSettings', err.msg)
        that.flagLoading.info = false
      })
    },
    getFreqGraph: function () {
      if (this.flagLoading.freqGraph) return
      this.flagLoading.freqGraph = true
      const url = '/api/v1/atk_player/admin/settings/mobile_freq_graph'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.freqGraph = { ...that.freqGraph, ...res.data.content }
        } else {
          console.error('getFreqGraph', res.msg)
        }
        that.flagLoading.freqGraph = false
      }).catch(function (err) {
        console.error('getFreqGraph', err.msg)
        that.flagLoading.freqGraph = false
      })
    },
    getMenu: function () {
      if (this.flagLoading.getMenu) return
      this.flagLoading.getMenu = true
      const url = '/api/v1/atk_player/admin/settings/mobile_menu'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.menu = { ...that.menu, ...res.data.content }
        } else {
          console.error('getMenu', res.msg)
        }
        that.flagLoading.getMenu = false
      }).catch(function (err) {
        console.error('getMenu', err.msg)
        that.flagLoading.getMenu = false
      })
    },
    updateSettings: function () {
      if (this.tabSelect === 'Frequency Graph') {
        this.updateFreqGraph()
      } else if (this.tabSelect === 'Menu') {
        this.updateMenu()
      } else {
        this.updateInfo()
      }
    },
    updateInfo: function () {
      if (this.flagLoading.update) return
      this.flagLoading.update = true
      const url = `/api/v1/atk_player/admin/settings/${this.infos.type}`
      const body = { content: { ...this.content } }
      const that = this
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          console.error('updateSettings', res.msg)
        }
        that.flagLoading.update = false
      }).catch(function (err) {
        console.error('updateSettings', err.msg)
        that.flagLoading.update = false
      })
    },
    updateFreqGraph: function () {
      if (this.flagLoading.update) return
      this.flagLoading.update = true
      const url = '/api/v1/atk_player/admin/settings/mobile_freq_graph'
      const body = { content: { ...this.freqGraph } }
      const that = this
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          console.error('updateSettings', res.msg)
        }
        that.flagLoading.update = false
      }).catch(function (err) {
        console.error('updateSettings', err.msg)
        that.flagLoading.update = false
      })
    },
    updateMenu: function () {
      if (this.flagLoading.update) return
      this.flagLoading.update = true
      const url = '/api/v1/atk_player/admin/settings/mobile_menu'
      const body = { content: { ...this.menu } }
      const that = this
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          console.error('updateMenu', res.msg)
        }
        that.flagLoading.update = false
      }).catch(function (err) {
        console.error('updateMenu', err.msg)
        that.flagLoading.update = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    updateContent: function (type, content) {
      this.content[type] = content
    }
  }
}
</script>

<style scoped lang="scss">
.infos-actions {
  margin-top: 30px;
  padding-left: 152px;
}
.freq-graph {
  .freq-item {
    margin-bottom: 20px;
    .item-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .item-content {
      .item-inputs {
        margin-bottom: 10px;
        .input-hz {
          width: 200px;
        }
      }
      .item-desc {
      }
    }
  }
}
.menu-list {
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
    .el-checkbox {
      margin-bottom: 10px;
    }
  }
}
</style>
